// Landing/FriendlyVideo.tsx
import React, {useEffect, useRef, useState} from 'react';
import PlayCircleRoundedIcon from '@mui/icons-material/PlayCircleRounded';
import {useTheme} from "Theme/ThemeContext";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';
import {FC, FCCC} from "WideLayout/Layouts";

interface FriendlyVideoProps {
    videoSrc: string;
}

const FriendlyVideo: React.FC<FriendlyVideoProps> = ({videoSrc}) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isHidden, setIsHidden] = useState(false);
    const [isPlaying, setIsPlaying] = useState(true);
    const [hasError, setHasError] = useState(false);
    const [volume, setVolume] = useState(5); // 1 to 10
    const videoRef = useRef<HTMLVideoElement>(null);
    const [isMobile, setIsMobile] = useState(false);
    const {plt} = useTheme()

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.volume = volume / 10;
            if (isExpanded) {
                videoRef.current.muted = false;
                videoRef.current.play().catch(() => setIsPlaying(false));
            } else {
                videoRef.current.muted = true;
                videoRef.current.play().catch(() => setIsPlaying(false));
            }
        }
    }, [isExpanded, volume]);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.currentTime = 0;
        }
    }, [isExpanded]);

    const togglePlayPause = () => {
        console.log('togglePlayPause')
        if (isExpanded && videoRef.current) {
            console.log('1 ')
            if (videoRef.current.paused) {
                videoRef.current.play();
                setIsPlaying(true);
                console.log('2')
            } else {
                videoRef.current.pause();
                setIsPlaying(false);
                console.log('3')
            }
        } else {
            console.log('4')
            setIsExpanded(true);
        }
    };

    const closeVideo = () => {
        setIsExpanded(false);
        setIsHidden(true);
        setIsPlaying(false);
    };

    const openVideo = () => {
        setIsHidden(false);
        setIsExpanded(true);
        setIsPlaying(true);
    };

    const handleError = () => {
        setHasError(true);
    };

    const decreaseVolume = (e: React.MouseEvent) => {
        e.stopPropagation();
        setVolume(prev => (prev > 1 ? prev - 1 : prev));
    };

    const increaseVolume = (e: React.MouseEvent) => {
        e.stopPropagation();
        setVolume(prev => (prev < 10 ? prev + 1 : prev));
    };

    const videoStyles: React.CSSProperties = {
        position: 'fixed',
        top: isExpanded ? '50%' : 'unset',
        left: isExpanded ? '50%' : 'unset',
        bottom: isExpanded ? 'unset' : '10px',
        right: isExpanded ? 'unset' : '10px',
        transform: isExpanded ? 'translate(-50%, -50%)' : 'none',
        width: isExpanded
            ? isMobile
                ? '90%'
                : 'auto'
            : '120px',
        height: isExpanded
            ? isMobile
                ? 'auto'
                : '80%'
            : 'auto',
        aspectRatio: '9 / 16',
        maxWidth: '90vw',
        maxHeight: '80vh',
        transition: 'all 0.5s ease',
        zIndex: 10,
        cursor: 'pointer',
        borderRadius: isExpanded ? '15px' : '10px',
        boxShadow: isExpanded ? '0 4px 8px rgba(0,0,0,0.3)' : 'none',
        overflow: 'hidden',
        opacity: hasError ? 0 : 1,
    };

    return (
        <>
            {!hasError && (
                <div

                    style={{
                        ...videoStyles,
                        opacity: isHidden ? 0 : 1,
                        pointerEvents: isHidden ? 'none' : 'auto',
                        padding: isExpanded ? 'unset' : '.23rem .16rem',
                    }}
                >
                    <FC pos={"relative"} w={'100%'} sx={{}}>
                        {!isExpanded && <RemoveRoundedIcon
                            style={{
                                zIndex: 24,
                                padding: '.13rem', fontSize: '1.6rem',
                                top: '-.16rem', right: '-.16rem', position: 'absolute',
                                background: plt.colors.secondary.light + 'dd', borderRadius: '50%',
                                color: plt.text.contrast80
                            }}
                            onClick={closeVideo}/>}
                        <video
                            ref={videoRef}
                            src={videoSrc}
                            autoPlay
                            loop
                            muted={!isExpanded}
                            onError={handleError}
                            style={{
                                zIndex: 23,
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                objectPosition: 'top',
                                borderRadius: isExpanded ? '15px' : '10px',
                                transition: 'all 0.5s ease',
                            }}
                            onClick={togglePlayPause}
                        />
                        {isExpanded && (
                            <>
                                <CloseRoundedIcon
                                    style={{
                                        zIndex: 23,
                                        padding: '.2rem', fontSize: '2.2rem',
                                        top: '1rem', right: '1rem', position: 'absolute',
                                        background: plt.bg.contrast15, borderRadius: '50%',
                                        color: plt.text.contrast80
                                    }}
                                    onClick={closeVideo}/>
                                {/*<FCEC py={9} pos={'absolute'} pEvents={false} zIndex={23} h={'100%'} w={'100%'}>*/}
                                {/*    /!*<LandButton sx={{*!/*/}
                                {/*    /!*    backgroundColor: plt.colors.primary.main,*!/*/}
                                {/*    /!*    padding: '.2rem .9rem',*!/*/}
                                {/*    /!*    borderRadius: '.3rem',*!/*/}
                                {/*    /!*    fontSize: '1.2rem',*!/*/}
                                {/*    /!*    minHeight: '2rem',*!/*/}
                                {/*    /!*    pointerEvents: 'all',*!/*/}
                                {/*    /!*    zIndex: 33,*!/*/}
                                {/*    /!*}} onClick={closeVideo}>*!/*/}
                                {/*    /!*    <a className={'tdn'} style={{color: '#fff'}} href={'#questions'}>Связаться</a>*!/*/}
                                {/*    /!*</LandButton>*!/*/}
                                {/*</FCEC>*/}
                                <RemoveRoundedIcon
                                    style={{
                                        zIndex: 24,
                                        padding: '.2rem', fontSize: '2.2rem',
                                        bottom: '1rem', left: '1rem', position: 'absolute',
                                        background: plt.bg.contrast15, borderRadius: '50%',
                                        color: plt.text.contrast80
                                    }}
                                    onClick={decreaseVolume}/>
                                <FCCC style={{
                                    zIndex: 25, width: '36px', height: '36px',
                                    bottom: '.9rem', left: volume === 10 ? '3.43rem' : '3.52rem', position: 'absolute',
                                    background: plt.bg.contrast15, borderRadius: '50%',
                                    color: plt.text.contrast80, lineHeight: '1rem',
                                    padding: '.2rem', fontSize: '1.5rem',
                                }}>{volume}</FCCC>
                                <AddRoundedIcon
                                    onClick={increaseVolume}
                                    style={{
                                        zIndex: 25,
                                        padding: '.2rem', fontSize: '2.2rem',
                                        bottom: '1rem', left: '6rem', position: "absolute",
                                        background: plt.bg.contrast15, borderRadius: '50%',
                                        color: plt.text.contrast80
                                    }}/>
                            </>
                        )}
                    </FC>
                </div>
            )}
            {hasError && (
                <div>
                    Ошибка загрузки видео.
                </div>
            )}
            {!hasError &&
                <PlayCircleRoundedIcon onClick={openVideo} sx={{
                    transform: isHidden ? 'scale(1)' : 'scale(0)',
                    opacity: isHidden ? 1 : 0,
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    color: plt.colors.primary.main,
                    bottom: '1rem',
                    position: 'fixed',
                    right: '1rem',
                }}/>
            }
        </>
    );
};

export default FriendlyVideo;
